import React, { useEffect } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";

const PerformanceChart = ({ chartData, chartHeight = "500px" }) => {
  useEffect(() => {
    // Create root element
    const root = am5.Root.new("chartdiv");

    // Create chart
    const chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: true,
        panY: true,
        wheelX: "panX",
        wheelY: "zoomX",
        pinchZoomX: true,
        paddingLeft: 0,
        paddingRight: 1,
      })
    );

    // Add cursor
    const cursor = chart.set("cursor", am5xy.XYCursor.new(root, {}));
    cursor.lineY.set("visible", false);

    // Create axes
    const xRenderer = am5xy.AxisRendererX.new(root, {
      minGridDistance: 30,
      minorGridEnabled: true,
    });

    xRenderer.labels.template.setAll({
      rotation: -90,
      centerY: am5.p50,
      centerX: am5.p100,
      paddingRight: 15,
    });

    xRenderer.grid.template.setAll({
      location: 1,
    });

    const xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        maxDeviation: 0.3,
        categoryField: "date", // Update to match your data field
        renderer: xRenderer,
        tooltip: am5.Tooltip.new(root, {}),
      })
    );

    const yRenderer = am5xy.AxisRendererY.new(root, {
      strokeOpacity: 0.1,
    });

    const yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        maxDeviation: 0.3,
        renderer: yRenderer,
      })
    );

    // Create series for contracts (number of contracts will dictate bar height)
    const series = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: "Contracts",
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "contract", // Bar height now reflects the number of contracts
        categoryXField: "date",
        tooltip: am5.Tooltip.new(root, {
          labelText:
            "Contracts: {valueY}\nProfit: £{profit}\nDate: {categoryX}",
        }),
      })
    );

    // Set bars to yellow
    series.columns.template.setAll({
      fill: am5.color("#468fed"), // Yellow color
      stroke: am5.color("#468fed"), // Yellow border
      cornerRadiusTL: 5,
      cornerRadiusTR: 5,
    });

    // Set data
    const data = [{ date: "09-09-2024", contract: 25, profit: 300 }];

    xAxis.data.setAll(chartData);
    series.data.setAll(chartData);

    // Make stuff animate on load
    series.appear(1000);
    chart.appear(1000, 100);

    // Cleanup on component unmount
    return () => {
      root.dispose();
    };
  }, [chartData]);

  return (
    <div id="chartdiv" style={{ width: "100%", height: chartHeight }}></div>
  );
};

export default PerformanceChart;
